// Generated by ReScript, PLEASE EDIT WITH CARE


var next_locale = "NEXT_LOCALE";

var web_tracking_id = "web_tracking_id";

var delivery_ck = "delivery_ck";

var visitorId = "visitor_id";

var auth_token = "auth-token";

var mobile = "mobile";

var dd_cookie = "_dd_s";

var ga_cookie = "_ga";

var ga_cookie_with_id = "_ga_SY9KC14QGC";

var gid_cookie = "_gid";

var fb_cookie = "_fbp";

export {
  next_locale ,
  web_tracking_id ,
  delivery_ck ,
  visitorId ,
  auth_token ,
  mobile ,
  dd_cookie ,
  ga_cookie ,
  ga_cookie_with_id ,
  gid_cookie ,
  fb_cookie ,
}
/* No side effect */
